import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAbacus } from '@fortawesome/pro-regular-svg-icons/faAbacus';

// FontAwesome regular (outlined) abacus icon. Wrapped so it conforms to the
// same component-with-no-props contract as the other nav icons in this
// directory (rendered as <IconComponent /> by NavIcon).
const StyledIcon = styled(FontAwesomeIcon)`
  height: 16px;
  width: 16px;
`;

export default function Abacus() {
  return <StyledIcon icon={faAbacus} />;
}
